import React from "react";
import GSTR2BReconciliationPage from "../../pages/GSTR2BReconciliationPage";

const Gstr2bSection: React.FC = () => {
  return <GSTR2BReconciliationPage />;
};

export default Gstr2bSection;
